import React from 'react';
import styled from "styled-components";

const SGrammarSubjuntivo = styled.div`
  flex: 1;
  padding: 5px 20px;
  td { padding: 5px; }
`;

const GrammarSubjuntivo = () => {
  return (
  <SGrammarSubjuntivo>
<h5>Modo Subjuntivo - Tryb łączący</h5>

<p>
Ten tryb nie istnieje w języku polskim. Używa się go w zdaniach złożonych (z dwoma różnymi podmiotami), według ściśle określonych reguł:
</p>

<li>Po czasownikach lub zwrotach oznaczających reakcję:</li>
<i>Me gusta que me <b>traigan</b> flores</i> - Lubię, jak mi przynoszą kwiaty
<li>Po czasownikach wyrażających opinię lub zmysły, ale tylko w przeczeniach:</li>
<i>No creo que <b>tengas</b> razón</i> - Nie sądzę, żebyś miał rację
<li>Po czasownikach lub zwrotach wyrażających wolę, życzenie, rozkaz, etc.:</li>
<i>Me pidió que le <b>ayudara</b></i> - Poprosił mnie, żebym mu pomógł
<li>Po zwrotach <i>ser</i> + przymiotnik + <i>que</i>, w których wyraża się swój pogląd:</li>
<i>Es mejor que <b>estudies</b></i> - Lepiej, żebyś się uczył
<li>W zdaniach czasowych odnoszących się do czynności późniejszej względem momentu mówienia:</li>
<i>Cuando <b>hayas llegado</b> a Madrid, ven a verme</i> - Kiedy przyjedziesz do Madrytu, odwiedź mnie
<li>Przy określaniu osób lub rzeczy, które mają spełnić jakiś warunek:</li>
<i>Quisiera tener una casa que <b>tuviera</b> un salón muy grande</i> - Chciałbym mieć dom, który miałby bardzo duży salon
<li>A także po ogromnej ilości innych zwrotów, np. <i>el hecho de que</i> (fakt, że), <i>sea como sea</i> (jakby nie było), <i>para que</i> (żeby), <i>a condición de que</i> (pod warunkiem, że), <i>aunque</i> (chociaż), <i>quizá</i> (być może), <i>ojalá</i> (oby), etc.</li>
<li>W mowie zależnej i w trybie rozkazującym.</li><br/>

<b>Presente de subjuntivo</b><br/><br/>
<table>
<tr><td>&nbsp;</td><td><u>habl<b>ar</b></u></td><td><u>com<b>er</b></u></td><td><u>viv<b>ir</b></u></td></tr>
<tr><td>(yo)</td>			    <td>habl<b>-e</b></td>			<td>com<b>-a</b></td>		<td>viv<b>-a</b></td></tr>
<tr><td>(tú)</td>         <td>habl<b>-es</b></td>			<td>com<b>-as</b></td>		<td>viv<b>-as</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td>habl<b>-e</b></td>			<td>com<b>-a</b></td>		<td>viv<b>-a</b></td></tr>
<tr><td>(nosotros/-as)</td>   <td>habl<b>-emos</b></td>			<td>com<b>-amos</b></td>	<td>viv<b>-amos</b></td></tr>
<tr><td>(vosotros/-as)</td>   <td>habl<b>-éis</b></td><td>com<b>-áis</b></td><td>viv<b>-ád</b></td></tr>
<tr><td>(ellos/-as/Vds.)</td>    <td>habl<b>-en</b></td>			<td>com<b>-an</b></td>		<td>viv<b>-an</b></td></tr>
</table>
<br/><br/>

<b>Pretérito Imperfecto de subjuntivo (I)</b><br/><br/>
<table>
<tr><td>&nbsp;</td><td><u>habl<b>ar</b></u></td><td><b>-er/-ir</b> (<u>beb<b>er</b></u>)</td></tr>
<tr><td>(yo)</td>			 <td>habl<b>-ara</b></td><td>beb<b>-iera</b></td></tr>
<tr><td>(tú)</td>      <td>habl<b>-aras</b></td><td>beb<b>-ieras</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td>habl<b>-ara</b></td><td>beb<b>-iera</b></td></tr>
<tr><td>(nosotros/-as)</td>   <td>habl<b>-áramos</b></td><td>beb<b>-iéramos</b></td></tr>
<tr><td>(vosotros/-as)</td>   <td>habl<b>-arais</b></td><td>beb<b>-ierais</b></td></tr>
<tr><td>(ellos/-as/Vds.)</td> <td>habl<b>-aran</b></td><td>beb<b>-ieran</b></td></tr>
</table>
<br/><br/>

<b>Pretérito Imperfecto de subjuntivo (II)</b><br/><br/>
<table>
<tr><td>&nbsp;</td><td><u>habl<b>ar</b></u></td><td><b>-er/-ir</b> (<u>viv<b>ir</b></u>)</td></tr>
<tr><td>(yo)</td>			 <td>habl<b>-ase</b></td><td>viv<b>-iese</b></td></tr>
<tr><td>(tú)</td>      <td>habl<b>-ases</b></td><td>viv<b>-ieses</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td>habl<b>-ase</b></td><td>viv<b>-iese</b></td></tr>
<tr><td>(nosotros/-as)</td>   <td>habl<b>-ásemos</b></td><td>viv<b>-iésemos</b></td></tr>
<tr><td>(vosotros/-as)</td>   <td>habl<b>-aseis</b></td><td>viv<b>-ieseis</b></td></tr>
<tr><td>(ellos/-as/Vds.)</td> <td>habl<b>-asen</b></td><td>viv<b>-iesen</b></td></tr>
</table>
<br/><br/>

<b>Pretérito Perfecto de subjuntivo</b><br/><br/>
<table>
<tr><td>(yo)</td><td><b>haya</b></td><td rowspan="6">+&nbsp;<b>Participio&nbsp;Pasado</b></td></tr>
<tr><td>(tú)</td>			<td><b>hayas</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td><b>haya</b></td></tr>
<tr><td>(nosotros/-as)</td>		<td><b>hayamos</b></td></tr>
<tr><td>(vosotros/-as)</td>		<td><b>hayáis</b></td></tr>
<tr><td>(ellos/-as/Vds.)</td>	<td><b>hayan</b></td></tr>
</table>
<br/><br/>

<b>Pretérito Plusquamperfecto de subjuntivo (I)</b><br/><br/>
<table>
<tr><td>(yo)</td><td><b>hubiera</b></td><td rowspan="6">+&nbsp;<b>Participio&nbsp;Pasado</b></td></tr>
<tr><td>(tú)</td>			<td><b>hubieras</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td><b>hubiera</b></td></tr>
<tr><td>(nosotros/-as)</td>		<td><b>hubiéramos</b></td></tr>
<tr><td>(vosotros/-as)</td>		<td><b>hubierais</b></td></tr>
<tr><td>(ellos/-as/Vds.)</td>	<td><b>hubieran</b></td></tr>
</table>
<br/><br/>

<b>Pretérito Plusquamperfecto de subjuntivo (II)</b><br/><br/>
<table>
<tr><td>(yo)</td><td><b>hubiese</b></td><td rowspan="6">+&nbsp;<b>Participio&nbsp;Pasado</b></td></tr>
<tr><td>(tú)</td>			<td><b>hubieses</b></td></tr>
<tr><td>(él/ella/Vd.)</td><td><b>hubiese</b></td></tr>
<tr><td>(nosotros/-as)</td>		<td><b>hubiésemos</b></td></tr>
<tr><td>(vosotros/-as)</td>		<td><b>hubieseis</b></td></tr>
<tr><td>(ellos/-as/Vds.)</td>	<td><b>hubiesen</b></td></tr>
</table>

  </SGrammarSubjuntivo>
  )
};

export default GrammarSubjuntivo;